export default function EFLaptop(props: any) {
    return (
        <svg width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Laptop_icon">
                    <rect id="矩形" x="0" y="0" width="30" height="30"></rect>
                    <g id="编组-37" strokeLinecap="round" strokeLinejoin="round" transform="translate(2.234330, 5.556284)" stroke={props.color || '#FFFFFF'}>
                        <path
                            d="M1.70427448,15.7060494 L1.70427448,1.20865205 C1.70427448,0.541237973 2.22399559,0 2.86527748,0 L22.5935526,0 C23.2348344,0 23.7545556,0.541237973 23.7545556,1.20865205 L23.7545556,15.7060494"
                            id="Stroke-147"
                        ></path>
                        <path
                            d="M25.1413053,18.8874308 L0.3900346,18.8874308 C0.174540483,18.8874308 0,18.7057778 0,18.4815023 L1.70427448,15.9352408 L23.7842183,15.9352408 L25.5313399,18.4815023 C25.5313399,18.7057778 25.3567994,18.8874308 25.1413053,18.8874308 Z"
                            id="Stroke-148"
                        ></path>
                        <line x1="12.3782076" y1="1.57789758" x2="13.4943372" y2="1.57789758" id="路径-6" strokeWidth="1.05871584"></line>
                    </g>
                </g>
            </g>
        </svg>
    );
}
